var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"rounded-lg w-1/4",attrs:{"src":require('@/assets/keyboard-3085978_1280.jpg'),"alt":"Testowy obrazek"}})])}
var staticRenderFns = []

export { render, staticRenderFns }